// What a walker broadcasts on her first frame in a scene: the server seeds a newcomer at its default spot,
// walking, and the walker broadcasts only while moving, so someone who arrived and stood still was seen there
// until her first step (owner G11, 2026-10-25). Hidden, she is riding, seated or driving: that controller
// says where she is. Left or right is read off her 8-way direction where she has one: the walker's own
// starts 'right' whichever way she came in.
import { facesLeft } from './dir8.mjs';

export function arrivalMove({ sprite, facing, mode, canBroadcast }) {
  if (!canBroadcast || !sprite || sprite.visible === false) return null;
  const side = Number.isInteger(sprite.facing8) ? (facesLeft(sprite.facing8) ? 'left' : 'right') : facing;
  return { x: sprite.x, y: sprite.y, facing: side, mode, dir: sprite.facing8 };
}
